import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "smartsearch-autocomplete__popup-container",
  class: "smartsearch-autocomplete__popup-container q-shadow q-p-2 q-bg-body q-rounded q-bg-white"
}

import {onMounted, toRefs, onUnmounted} from 'vue';
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";

import AutocompleteInputContainer from '@/components/AutocompletePopup/AutocompleteInputContainer.vue';
import LinearLoader from '@/components/LinearLoader.vue';
import OverlayLoader from '@/components/OverlayLoader.vue';
import AutocompleteContent from '@/components/AutocompletePopup/AutocompleteContainer.vue';
import {useMobileViewStore} from "@/store/MobileViewStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'AutocompletePopup',
  setup(__props) {

const popupStore = usePopupStore()
const {showAutocompletePopup, loading} = toRefs(popupStore)
const mobileViewStore = useMobileViewStore();


onUnmounted(() => {
  window.removeEventListener('resize', mobileViewStore.updateIsMobileView);
});

onMounted(() => {
  window.addEventListener('resize', mobileViewStore.updateIsMobileView);
  document.addEventListener('click',(event)=> popupStore.handleClickOutside(event));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AutocompleteInputContainer),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(OverlayLoader, { loading: _unref(loading) }, null, 8, ["loading"]),
      _createVNode(LinearLoader, { loading: _unref(loading) }, null, 8, ["loading"]),
      _createVNode(AutocompleteContent)
    ], 512), [
      [_vShow, _unref(showAutocompletePopup)]
    ])
  ]))
}
}

})